import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchdatasss = (special: any) => ({
    type: 'FETCH_SPEC_SUCCESS',
    payload: special,
});
export const fetchsi = (sick: any) => ({
    type: 'FETCH_SIC_SUCCESS',
    payload: sick,
});
export const fetchdataname = (specialname: any) => ({
    type: 'FETCH_SPECName_SUCCESS',
    payload: specialname,
});

export const fetchname = (name: any) => ({
    type: 'FETCH_NAME_SUCCESS',
    payload: name,
});
export const fetchCountries = (country: any) => ({
    type: 'FETCH_COUN_SUCCESS',
    payload: country,
});
export const updateDoctors = (edit: any) => ({
    type: 'FETCH_EDIT_SUCCESS',
    payload: edit,
});
export const removeData = (remove: any) => ({
    type: 'FETCH_REMOVE_SUCCESS',
    payload: remove,
});
export const fetchDocotrsList = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,uid:uid};
            const apiname = SUPRIVISOR_API.sdoctorget;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getSpeciality = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid};
            const apiname = DOCTOR_API.speciality_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasss(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getSickness = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid};
            const apiname = SUPRIVISOR_API.sickess_LIST;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchsi(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getSpecialityName = (SpecilityName:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {special:SpecilityName,q:8};
            const apiname = SUPRIVISOR_API.sdashboard;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdataname(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getCountries = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = SUPRIVISOR_API.countrydata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchCountries(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const editDoctors = (FirstName:any,lastName:any,Email:any,Phone:any,CoountryID:any,SpecilityName:any,id:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {fname:FirstName,lname:lastName,email:Email,phone:Phone,country:CoountryID,speciality:SpecilityName,did:id,uid:uid,q:3};
            const apiname = SUPRIVISOR_API.sdoctorget;
            const response = await LoginService.getData(apiname,payload);
            dispatch(updateDoctors(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const DeleteDoctor = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {did:id,q:4};
            const apiname = SUPRIVISOR_API.sdoctorget;
            const response = await LoginService.getData(apiname,payload);
            dispatch(removeData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};